import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fetchAdvisoryBanners } from "../api/contentfulService";

export const useAdvisoryBanners = () => {
  const [banners, setBanners] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    fetchAdvisoryBanners(i18n.language)
      .then((data) => {
        console.log("[useAdvisoryBanners] ✅ Fetched banners:", data);
        setBanners(data);
      })
      .catch((err) => {
        console.warn("[useAdvisoryBanners] ⚠️ Failed to fetch banners:", err);
        setBanners([]);
      });
  }, [i18n.language]);

  return banners;
};
